// this is an autogenerated file from App/Account/Content/Settings/Content/SecureValue/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_SecureValue($value: String!) {
  encrypt(value: $value) {
    value
  }
}

`